var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"play-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleClick($event)}}},[_c('i',{staticClass:"icon icon-playback"}),_vm._v(" "+_vm._s(_vm.$t('button_common_playback'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }